import { render, staticRenderFns } from "./custom_menu.vue?vue&type=template&id=38b7e23e&scoped=true"
import script from "./custom_menu.vue?vue&type=script&lang=js"
export * from "./custom_menu.vue?vue&type=script&lang=js"
import style0 from "./custom_menu.vue?vue&type=style&index=0&id=38b7e23e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b7e23e",
  null
  
)

export default component.exports